<template>
  <div ui-view="" class="app-body" id="view">
    <agree-item
    :item="item"
    v-for="(item, index) in agreeItems"  :key="index" @agreeCheckEvent="agreeCheckHandler" @agreeOpenEvent="agreeOpenEventHandler"/>
    <div class="mt-20">
      <small>
        <label class="md-check">
        <input type="checkbox" v-model="isCheckAll" @change="checkAllHandler">
        <i class="blue"></i>모든 약관에 동의합니다.</label>
      </small>
    </div>
    <div class="btn-wrap mt-30 mb-30 justify-content-center">

      <button class="btn btn-lg line-2" @click="prev()" v-if="showPrev"><i class="icon-arrow-line-left mr-5"></i>이전</button>
      <button class="btn btn-lg blue" @click="next()" v-if="showNext" :disabled="isCheckNext">다음<i class="icon-arrow-line-right  ml-5"></i></button>
    </div>
  </div>

</template>

<script>
import AgreeItem from '@/views/app/main/AgreeItem.vue';
export default {
  components: {AgreeItem },
  props: ['item', 'items', 'isEmployee'],
  data(){
    return {
      agreeItems:[
        {'tosTitle' : 'IDC 출입 필수 사항', }
      ],
      checkedAll: false
    }
  },
  computed: {
    showPrev() {
      return this.item.id <= 1 ? false : true;
    },
    showNext(){
      return this.item.id <= this.items.length
    },
    isCheckNext() {
      if(!this.agreeItems)
        return false;
      this.checkedAll = this.agreeItems.filter((item)=>{return item.isChecked}).length != this.agreeItems.length;
      return this.agreeItems.filter((item)=>{return item.isChecked}).length != this.agreeItems.length;
    },
    isCheckAll() {
      return !this.isCheckNext
    }
  },
  mounted(){

    this.loadItems();
  },
  methods: {
    prev(){
      this.$emit('changeStep', {item: this.item, action: -1})
    },
    next(){
      this.$emit('changeStep', {item: this.item, tos:this.agreeItems, action: 1})
    },
    getQuery(){
      var query = Object.assign({},this.$route.query);
      var tosList = this.agreeItems.filter((item)=>{return item.isChecked});
            query.tos = JSON.stringify(_.chain(tosList)
      .keyBy('tosIndex')
      .mapValues('isChecked')
      .value());
      return query;
    },
    loadItems(){
      var that = this;
      this.$http.get('/api/tos')
        .then((result) => {
          result.data.forEach((item) => {
            item.isOpen = false
            if(this.$attrs.data.isApplicant == 0) {
              item.isChecked = false;
            }else{
              item.isChecked = true;
              item.isOpen = true;
            }
          })
          that.agreeItems = result.data.filter(x=>x.isEnable==1);
          if(this.$attrs.data.isApplicant == 1 || this.isEmployee) {
            this.next();
          }
        }).catch((e) =>{
      })
    },
    checkAllHandler(){
      this.agreeItems.forEach((item)=>{
        // item.isChecked = this.isCheckAll;
        debugger;
        item.isChecked = this.checkedAll;
        item.isOpen = this.checkedAll;
      })
    },
    agreeCheckHandler(data){
      var that = this;
      debugger;
      this.agreeItems.forEach((item)=>{
        if(data.tosIndex == item.tosIndex) {
          item.isChecked = data.isChecked;
          item.isOpen = data.isChecked
          return;
        }
      })
    },
    agreeOpenEventHandler(data) {
      debugger;
      var that = this;
      this.agreeItems.forEach((item)=>{
        if(data.tosIndex == item.tosIndex) {
          item.isOpen = !data.isOpen;
          return;
        }
      })
    }
  }
}
</script>

<style>

